import axios from "axios";

export const axiosInstance = axios.create({
  baseURL: "https://kz-chat-api.onrender.com/api",
  withCredentials: true,
});
